import { render, staticRenderFns } from "./getWays.vue?vue&type=template&id=38ac9ef3&scoped=true"
import script from "./getWays.vue?vue&type=script&lang=js"
export * from "./getWays.vue?vue&type=script&lang=js"
import style0 from "./getWays.vue?vue&type=style&index=0&id=38ac9ef3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac9ef3",
  null
  
)

export default component.exports